import * as React from 'react';

import {getApiTypeFromGraphQLTypename} from 'nutshell-core/utils';

import {Popover} from '../../popover/popover';
import {SelectableListSingle} from '../../selectable-list/selectable-list';

import {isTextableDisabled, getSubtitleForTextable, getThirdLineForTextable} from '../helpers';
import type {Textable} from '../types';

import styles from './textable-select.module.css';

const HAS_SEARCH_THRESHOLD = 7;

type Props = {
    anchor: HTMLElement | null | undefined;
    anchorElementId?: string;
    textables: Textable[];
    selectedTextable: Textable | null | undefined;
    onSelectTextable: (textable: Textable) => void;
    setIsPopoverOpen: (isPopoverOpen: boolean) => void;
};

export function TextableSelectPopover(props: Props) {
    return (
        <Popover
            anchor={props.anchor}
            anchorElementId={props.anchorElementId}
            location='bottom'
            onBlur={() => props.setIsPopoverOpen(false)}
        >
            <div className={styles['form-body']}>
                {/* @ts-expect-error */}
                <SelectableListSingle
                    collection={props.textables.map((textable) => {
                        return {
                            id: textable.id,
                            type: getApiTypeFromGraphQLTypename(textable.__typename),
                            name: textable.name,
                            avatarUrl: textable.avatarUrl,
                            subtitle: getSubtitleForTextable(textable),
                            thirdLine: getThirdLineForTextable(textable),
                            isDisabled: isTextableDisabled(textable),
                        };
                    })}
                    value={props.selectedTextable ? props.selectedTextable.id : null}
                    hasSearch={props.textables.length > HAS_SEARCH_THRESHOLD}
                    autoFocusSearch={true}
                    isNewStyle={true}
                    alwaysHasValue={true}
                    onSelect={(id?: string | null) => {
                        const textable = props.textables.find((t) => t.id === id);
                        if (textable) {
                            props.onSelectTextable(textable);
                        }
                        props.setIsPopoverOpen(false);
                    }}
                />
            </div>
        </Popover>
    );
}
